import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'coin-star',
  standalone: true,
  template: `
    <svg
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      opacity="0.2"
      [attr.width]="size()"
      [attr.height]="size()">
      <path
        d="M7.65077 0.67824C7.95794 -0.226385 9.23739 -0.226387 9.54457 0.678238L10.9137 4.71023C11.0514 5.11586 11.4322 5.3887 11.8606 5.3887H16.1941C17.1735 5.3887 17.569 6.65074 16.7649 7.20978L13.336 9.59364C12.9699 9.8481 12.8165 10.3141 12.9599 10.7362L14.2873 14.6455C14.5976 15.5592 13.5618 16.3389 12.7696 15.7882L9.16849 13.2846C8.82533 13.046 8.37 13.046 8.02684 13.2846L4.42572 15.7882C3.63351 16.3389 2.59777 15.5592 2.908 14.6455L4.23545 10.7362C4.37879 10.3141 4.2254 9.8481 3.85937 9.59364L0.430415 7.20978C-0.373715 6.65074 0.0218725 5.3887 1.00124 5.3887H5.33475C5.76313 5.3887 6.14392 5.11586 6.28165 4.71024L7.65077 0.67824Z"
        fill="var(--blue100, #7eb3e8)" />
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StarComponent {
  size = input<number>(18);
}
